<template>
    <div class="member-center">
        <!-- 页面标题 -->
        <div class="section-header">
            <div class="headerLeft">
                <span class="line"></span>
                我的钱包
            </div>
        </div>

        <!-- 账户余额区域 -->
        <div class="wallet-balance">
            <div>
                <div class="balance-label">账户余额</div>
                <div class="balance-amount">{{ walletDetail.user_money || 0 }}元</div>
            </div>
            <div class="balance-actions">
                <!-- 点击"去充值"时显示余额操作按钮 -->
                <el-button type="primary" class="balance-btn1" @click="changeType(1)"
                    v-if="!showYueActions">去充值</el-button>

                <!-- 余额操作按钮组 -->
                <div class="yue-acitons" v-if="showYueActions">
                    <el-button type="primary" class="balance-btn1" @click="handleWithdraw">余额提现</el-button>
                    <el-button type="primary" class="balance-btn2" @click="changeType(2)">余额明细</el-button>
                </div>
            </div>
        </div>

        <!-- 充值区域 -->
        <div class="recharge-section" v-if="showYueActions">
            <!-- 选择充值金额 -->
            <div class="item-label">选择充值金额</div>
            <div class="amount-options">
                <div class="amount-option" v-for="amount in presetAmounts" :key="amount.aid"
                    :class="{ active: selectedAmount == amount.aid }" @click="selectAmount(amount)">
                    {{ amount.name }}
                </div>
            </div>
            <!-- 自定义输入金额 -->
            <div class="recharge-item">
                <div class="item-label">自定义输入金额</div>
                <div class="custom-amount">
                    <span class="currency-symbol">¥</span>
                    <el-input v-model="customAmount" placeholder="请输入充值金额" @input="onCustomAmountInput"
                        type="number"></el-input>
                </div>
            </div>

            <!-- 选择支付方式 -->
            <div class="recharge-item">
                <div class="item-label">选择支付方式</div>
                <div class="payment-options">
                    <div class="payment-option" v-for="(payment, index) in paymentMethods" :key="index"
                        :class="{ active: selectedPayment === index }" @click="selectPayment(index)">
                        <img :src="payment.icon" :alt="payment.name">
                        <span>{{ payment.name }}</span>
                    </div>
                </div>
            </div>

            <!-- 立即充值按钮 -->
            <div class="recharge-action">
                <el-button type="primary" size="large" class="recharge-btn" @click="handleRecharge">立即充值</el-button>
            </div>
        </div>


        <!-- 提现记录区域 -->
        <div class="withdraw-record-section" v-if="!showYueActions">
            <!-- 记录类型切换 -->
            <div class="record-tabs">
                <el-tabs v-model="activeTab" class="left-tabs" @tab-click="handleTabClick">
                    <el-tab-pane label="全部" name="0"></el-tab-pane>
                    <el-tab-pane label="收入记录" name="1"></el-tab-pane>
                    <el-tab-pane label="支出记录" name="2"></el-tab-pane>
                </el-tabs>
                <div class="date-range right-date-range">
                    <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small"
                        @change="getBalanceDetail" />
                </div>
            </div>

            <!-- 记录表格 -->
            <div class="record-table">
                <table>
                    <thead>
                        <tr>
                            <th>明细</th>
                            <th>金额</th>
                            <!-- <th>提现状态</th> -->
                            <th>订单号</th>
                            <th>时间</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="record in withdrawRecords" :key="record.id">
                            <td>{{ record.remark }}</td>
                            <td class="amount" :style="record.money_type == 1 ? 'color:green' : 'color:red'"><span
                                    v-if="record.money_type == 1">+</span>{{
                                        record.change_money }}</td>
                            <!-- <td :class="'status-' + record.status">{{ record.statusText }}</td> -->
                            <td>{{ record.order_sn }}</td>
                            <td>{{ record.create_time }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- 分页控件 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
                </el-pagination>
            </div>

        </div>
        <!-- 充值支付二维码弹窗 -->
        <el-dialog :title="payQRType == 'wx' ? '微信支付' : '支付宝支付'" :visible.sync="payDialogVisible" width="520px" center
            :close-on-click-modal="false" @close="closePayDialog" custom-class="recharge-pay-dialog" :show-close="true">
            <div class="recharge-pay-box">
                <div class="recharge-pay-amount">
                    支付金额：<span class="pay-money">¥{{ payMoney }}</span>
                </div>
                <div class="recharge-pay-qr">
                    <img v-if="payQRType == 'wx'" :src="payQRUrl" alt="支付二维码">
                    <iframe v-else :src="payQRUrl" frameborder="0" width="500" height="500"></iframe>
                </div>
                <!-- <div class="recharge-pay-tip">请扫最新二维码，请勿重复支付</div> -->
            </div>
        </el-dialog>
    </div>


</template>

<script>
import { get } from 'core-js/core/dict';

export default {
    name: 'MyWallet',
    data() {
        return {
            // 预设充值金额选项
            presetAmounts: [],
            // 选中的充值金额
            selectedAmount: '1',
            // 自定义金额
            customAmount: '',
            // 支付方式
            paymentMethods: [
                { name: '微信支付', icon: require('@/assets/images/56.png'), type: 'wx' },
                { name: '支付宝支付', icon: require('@/assets/images/57.png'), type: 'alipay' }
            ],
            // 选中的支付方式索引
            selectedPayment: 0,
            // 钱包详情
            walletDetail: {},
            // 显示充值区域
            showRecharge: true,
            // 显示提现记录
            showWithdrawRecord: false,
            // 日期范围
            dateRange: [],
            // 提现记录数据
            withdrawRecords: [

            ],
            // 控制余额操作按钮显示
            showYueActions: true,
            // 当前激活的标签页
            activeTab: '0',

            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,

            // 支付二维码弹窗
            payDialogVisible: false,
            payQRUrl: '',          // 微信二维码图片 / 支付宝跳转链接
            payQRType: '',         // wx / alipay
            payOrderSn: '',        // 当前充值订单号
            payMoney: '',          // 当前充值金额
            payPollingTimer: null, // 支付状态轮询定时器
        }
    },
    mounted() {
        this.getRechargeOptions()
        this.getWalletDetail()
    },
    methods: {

        changeType(type) {
            if (type == 1) {
                this.getWalletDetail()
                this.showYueActions = true;

            } else {
                this.getBalanceDetail();
                this.showWithdrawRecord = true;
                this.showYueActions = false
            }

        },

        // 跳转提现页面
        handleWithdraw() {
            this.$parent.currentComponent = 'Withdraw';
            this.$parent.componentParams = { Money: this.walletDetail.user_money };
        },

        handleTabClick(tab) {
            this.activeTab = tab.name;
            this.getBalanceDetail();
        },

        // 选择预设金额
        selectAmount(amount) {
            this.selectedAmount = amount.aid;
            this.customAmount = '';
        },

        // 自定义金额输入
        onCustomAmountInput() {
            if (this.customAmount) {
                this.selectedAmount = '';
            }
        },

        // 选择支付方式
        selectPayment(index) {
            this.selectedPayment = index;
        },

        // 立即充值
        handleRecharge() {
            let payableMoney = '';
            let productId = '';
            if (this.customAmount) {
                payableMoney = this.customAmount;
            } else if (this.selectedAmount) {
                const selected = this.presetAmounts.find(item => item.aid === this.selectedAmount);
                payableMoney = selected ? selected.payable_money : '';
                productId = selected ? selected.aid : '';
            }
            if (!payableMoney || Number(payableMoney) <= 0) {
                this.$message.warning('请输入或选择有效的充值金额');
                return;
            }
            const data = {
                payable_money: String(payableMoney),
                pay_type: this.paymentMethods[this.selectedPayment].type, // wx / alipay
            };
            if (productId) {
                data.product_id = String(productId);
            }

            this.$api.recharge(data).then(res => {
                // 充值下单成功，根据支付方式获取二维码并弹窗
                this.payOrderSn = res.order_sn;
                this.payQRType = data.pay_type;
                this.payMoney = payableMoney;
                this.getRechargePayInfo(res.order_sn, data.pay_type);
            }).catch(err => {
                this.$message.error(err.message || err);
            })
        },
        // 获取充值支付二维码/链接（复用支付页接口）
        getRechargePayInfo(orderSn, payType) {
            const api = payType === 'wx' ? this.$api.getWxPayInfo : this.$api.getPayInfo;
            api({ order_sn: orderSn, order_config_id: 20 }).then(res => {
                this.payQRUrl = payType === 'wx' ? res.qrcode : res.url;
                this.payDialogVisible = true;
                // 开始轮询支付状态
                this.startPayPolling();
            }).catch(err => {
                this.$message.error(err.message || err);
            });
        },
        // 轮询充值支付状态
        startPayPolling() {
            this.clearPayPolling();
            this.payPollingTimer = setInterval(() => {
                this.$api.getPayResult({ order_sn: this.payOrderSn, order_config_id: 20 }).then(res => {
                    this.clearPayPolling();
                    this.payDialogVisible = false;
                    this.$message.success('充值成功');
                    // 刷新钱包余额
                    this.getWalletDetail();
                }).catch(() => { });
            }, 2000);
        },
        // 清除轮询
        clearPayPolling() {
            if (this.payPollingTimer) {
                clearInterval(this.payPollingTimer);
                this.payPollingTimer = null;
            }
        },
        // 关闭支付弹窗
        closePayDialog() {
            this.clearPayPolling();
            this.payDialogVisible = false;
        },

        // 获取充值选项
        getRechargeOptions() {
            this.$api.getRechargeOptions().then(res => {
                this.presetAmounts = res || [];
                this.selectedAmount = this.presetAmounts.length > 0 ? this.presetAmounts[0].aid : '';
            })
        },

        // 获取钱包详情
        getWalletDetail() {
            this.$api.getWalletDetail().then(res => {
                this.walletDetail = res || {};
            })
        },

        // 获取余额明细
        getBalanceDetail() {
            let data = {
                create_time: this.dateRange ? this.dateRange[0] : '',
                money_type: this.activeTab,
                end_time: this.dateRange ? this.dateRange[1] : '',
                page: this.currentPage,
                list_rows: this.pageSize,
            }
            this.$api.getBalanceDetail(data).then(res => {
                this.withdrawRecords = res.data || [];
                this.totalOrders = res.total || 0;
            })
        },

        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getBalanceDetail();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getBalanceDetail();
        },
    }
}
</script>

<style scoped>
.member-center {
    background-color: #ffffff;
    border-radius: 8px;
}

/* 页面标题 */
.section-header {
    margin-bottom: 20px;
}

.headerLeft {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
}

.line {
    display: block;
    width: 4px;
    height: 18px;
    background-color: #286CED;
    border-radius: 2px;
    margin-right: 12px;
}

/* 账户余额区域 */
.wallet-balance {
    background: url(~@/assets/images/55.png) no-repeat;
    background-size: 100% auto;
    color: #ffffff;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 20px;
    display: flex;
    align-items: end;
    justify-content: space-between;
}

.balance-label {
    font-size: 16px;
    margin-bottom: 10px;
    text-align: left;
}

.balance-amount {
    font-size: 28px;
    font-weight: 600;
    text-align: left;
}

.balance-actions {
    display: flex;
    gap: 12px;
}

.balance-btn1 {
    width: 110px;
    height: 40px;
    border-radius: 20px 20px 20px 20px;
    border: 1px solid #FFFFFF;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    background-color: #3A73EB;
}

.balance-btn2 {
    width: 110px;
    height: 40px;
    border-radius: 20px 20px 20px 20px;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    background-color: rgba(255, 255, 255, 0.3);
}

.balance-actions .el-button {
    color: #ffffff;
    border-color: #ffffff;
}

.balance-actions .el-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

/* 充值区域 */
.recharge-section {
    background-color: #ffffff;
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 8px;
}

.recharge-item {
    margin-bottom: 24px;
}

.item-label {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 16px;
    text-align: left;
}

/* 预设金额选项 */
.amount-options {
    display: flex;
    gap: 5%;
    flex-wrap: wrap;
}

.amount-option {
    width: 20%;
    height: 72px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #333333;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 20px;
}

.amount-option:hover {
    border-color: #286CED;
}

.amount-option.active {
    border-color: #286CED;
    background-color: rgba(40, 108, 237, 0.1);
    color: #286CED;
}

/* 自定义金额输入 */
.custom-amount {
    display: flex;
    align-items: center;
    width: 300px;
}

.currency-symbol {
    font-size: 16px;
    color: #333333;
    margin-right: 8px;
}

.custom-amount .el-input {
    width: 100%;
}

/* 支付方式选项 */
.payment-options {
    display: flex;
    gap: 24px;
}

.payment-option {
    width: 140px;
    height: 50px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    transition: all 0.3s ease;
}

.payment-option img {
    width: 24px;
    height: 24px;
}

.payment-option:hover {
    border-color: #286CED;
}

.payment-option.active {
    border-color: #286CED;
    background-color: rgba(40, 108, 237, 0.1);
}

/* 立即充值按钮 */
.recharge-action {
    margin-top: 32px;
    text-align: center;
}

.recharge-btn {
    width: 200px;
    height: 48px;
    font-size: 16px;
    background-color: #286CED;
    border-color: #286CED;
}

.recharge-btn:hover {
    background-color: #1e5bd8;
    border-color: #1e5bd8;
}

/* 提现记录区域 */
.withdraw-record-section {
    background-color: #ffffff;
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 8px;
}

/* 记录标签 */
.record-tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.left-tabs {
    flex: 1;
    max-width: 300px;
}

.right-date-range {
    /* width: 250px; */
    margin-left: 20px;
}

/* 隐藏Element UI tabs的默认边框 */
.left-tabs .el-tabs__header {
    border-bottom: none;
}

.left-tabs .el-tabs__nav {
    border-bottom: 1px solid #e4e7ed;
}

.left-tabs .el-tabs__item {
    color: #333;
    font-size: 14px;
    font-weight: 500;
}

.left-tabs .el-tabs__item.is-active {
    color: #286CED;
    border-bottom: 2px solid #286CED;
}

::v-deep .el-tabs__nav-wrap::after {
    background-color: #fff;
}

/* 记录表格 */
.record-table {
    overflow-x: auto;
}

table {
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    padding: 12px 8px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;
}

th {
    background-color: #fafafa;
    color: #666;
    font-weight: 500;
}

.amount {
    color: #ff0000;
}

.status-rejected {
    color: #ff4d4f;
}

.status-completed {
    color: #67c23a;
}

.status-processing {
    color: #e6a23c;
}

/* 分页容器 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;

}

/* 响应式设计 */
@media (max-width: 768px) {
    .amount-options {
        justify-content: center;
    }

    .custom-amount {
        width: 100%;
    }

    .payment-options {
        justify-content: center;
    }

    .record-tabs {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .date-range {
        width: 100%;
    }
}

/* 充值支付二维码弹窗 */
.recharge-pay-dialog .el-dialog__body {
    padding: 0 20px 20px;
}

.recharge-pay-box {
    text-align: center;
}

.recharge-pay-amount {
    font-size: 15px;
    color: #333;
    margin-bottom: 20px;
}

.recharge-pay-amount .pay-money {
    color: #ff4d4f;
    font-size: 20px;
    font-weight: 600;
}

.recharge-pay-qr {
    margin: 0 auto 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.recharge-pay-qr img {
    width: 200px;
    height: 200px;
}

.recharge-pay-alipay {
    width: 100%;
    min-height: 320px;
    overflow: auto;
    text-align: center;
}

.recharge-pay-alipay :deep(img) {
    max-width: 100%;
    height: auto;
    margin: 0 auto;
}

.recharge-pay-alipay :deep(form) {
    display: inline-block;
}

.recharge-pay-tip {
    font-size: 13px;
    color: #999;
    margin-top: 8px;
}
</style>